import loadingStatuses from '@constants/loadingStatuses';
import {
  Folder,
  IdResponse,
  FileResponse,
  Tag,
  Tags,
  FileResponseContainer,
} from 'respona_api/generated/common_pb';

export enum AppTypes {
  app = 'respona_app',
  concierge = 'respona_concierge',
  publisher = 'respona_publisher',
}

export type MetadataType = { Authorization?: string; 'X-UI-VERSION'?: string; 'X-REALM'?: string };
export type LSType = (typeof loadingStatuses)[keyof typeof loadingStatuses];
export type IdResponseType = IdResponse.AsObject;
export type FileResponseType = FileResponse.AsObject;

export enum PairTypeEnum {
  NUMBER = 0,
  STRING = 1,
  DOUBLE = 2,
  TIMESTAMP = 3,
}

export type PairType = {
  name: string;
  value: string;
  type: PairTypeEnum;
};

export type FolderType = Folder.AsObject;

export type TagType = Tag.AsObject;

export type TagsType = Tags.AsObject;

export type EditorSelectionType = {
  focus: {
    offset: number;
    path: number[];
  };
  anchor: {
    offset: number;
    path: number[];
  };
};

export type NoteType = {
  id: number;
  content: string;
  createdAt: number;
  relatedId: number;
  ownerId: number;
};

export type AudioGenreType = {
  uid: number;
  title: string;
};

export type EmailSuggestionType = {
  order: number;
  email: string;
};

export type CampaignEmailSuggestionType = {
  ccEmailsList: EmailSuggestionType[];
  bccEmailsList: EmailSuggestionType[];
};

export type StateItemsListType<T> = {
  items: T[];
  loadingStatus: string;
};

export type FileAttachmentType = {
  key: string;
  title: string;
  size: number;
};

export type DateRangeNumberType = {
  startDate: number;
  endDate?: number;
};
export type DateRangeDateType = {
  startDate: Date;
  endDate: Date;
};

export type SelectOptionType<T = string> = {
  value: T;
  label: string;
};

export type ColumnSettingsType = {
  // id: number;
  columnTitle: string;
  columnMappingName: string;
  // order: number;
  enabled: boolean;
  // custom: boolean;
};

export type QueryCollectionHookType<T, ID = number> = {
  items: T[];
  refetch: () => void;
  isLoading: boolean;
  isEmpty: boolean;
  evictByKey: (id: ID) => void;
  addItem: (item: T) => void;
  addItems?: (items: T[]) => void;
  removeItem: (id: ID) => void;
  removeItems?: (ids: ID[]) => void;
  updateItem: (id: ID, item: T) => void;
  updateItems?: (items: T[]) => void;
  resetCache?: () => void;
};

export type QueryPageHookType<T, ID = number> = {
  items: T[];
  refetch: () => void;
  isLoading: boolean;
  isLoadingNextPage: boolean;
  hasNextPage: boolean;
  fetchNextPage: () => void;
  evictByKey: (id: ID) => void;
  addItem: (item: T) => void;
  addItems?: (items: T[]) => void;
  removeItem: (id: ID) => void;
  removeItems?: (ids: ID[]) => void;
  updateItem: (id: ID, item: T) => void;
  updateItems?: (items: T[]) => void;
  resetCache?: () => void;
};

export type QueryPageExtendedHookType<T, ID = number> = QueryPageHookType<T, ID> & {
  addItems: (items: T[]) => void;
};

export type QueryObjectHookType<T, ID = number> = {
  item: T;
  refetch: () => void;
  isLoading: boolean;
  /** True when the query rejected. Without this, consumers render a silent blank state. */
  isError?: boolean;
  error?: unknown;
  update: (payloadId: ID, payload: T) => void;
  evictByKey: (id: ID) => void;
};

export type FileResponseContainerType = FileResponseContainer.AsObject;
